<div class="login-page">
  <section class="login-shell">
    <aside class="brand-panel" aria-labelledby="login-title">
      <a class="brand-link" routerLink="/" aria-label="FlowStudio home">
        <img src="/assets/flow-studio-logo-90.png" alt="" />
        <span>FlowStudio</span>
      </a>

      <div class="brand-copy">
        <p class="eyebrow">Secure access center</p>
        <h1 id="login-title">Power Automate operations, with your Microsoft account in control.</h1>
        <p>
          FlowStudio uses Microsoft Entra sign-in and delegated Power Platform permissions.
          You stay inside your tenant controls, RBAC, DLP, and admin policies.
        </p>
      </div>

      <div class="trust-list" aria-label="FlowStudio security summary">
        <div class="trust-item">
          <i class="ms-Icon ms-Icon--AzureLogo" aria-hidden="true"></i>
          <span>Microsoft Entra authentication</span>
        </div>
        <div class="trust-item">
          <i class="ms-Icon ms-Icon--Permissions" aria-hidden="true"></i>
          <span>Delegated Power Platform access</span>
        </div>
        <div class="trust-item">
          <i class="ms-Icon ms-Icon--Shield" aria-hidden="true"></i>
          <span>No Microsoft passwords or connector secrets stored</span>
        </div>
      </div>

      <a class="security-link" href="https://flowstudio.app/security/" target="_blank" rel="noopener noreferrer">
        Security architecture review
        <i class="ms-Icon ms-Icon--OpenInNewWindow" aria-hidden="true"></i>
      </a>
    </aside>

    <main class="login-panel">
      <div class="panel-header">
        <p class="eyebrow">Sign in</p>
        <h2>Continue to FlowStudio</h2>
        <p>Use your Microsoft work account to continue.</p>
      </div>

      @if (this.user$ | async; as user) {
        <div class="status-card signed-in">
          <div>
            @if (countdown === null && !redirecting) {
              <p class="status-label">Signed in as</p>
              <p class="status-value">{{ displayUser(user) }}</p>
            }
          </div>
          <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
            <button kendoButton type="button" class="primary-action" themeColor="primary" [disabled]="redirecting" (click)="welcomeBack($event)">
              <fa-icon [icon]="redirecting ? 'spinner' : 'arrow-circle-right'" [spin]="redirecting"></fa-icon>
              Continue with {{ displayUser(user) }}
            </button>
            @if (countdown !== null) {
              <p class="status-countdown">
                Redirecting in {{ countdown }}…
                <button type="button" class="cancel-countdown" (click)="cancelCountdown()">Cancel</button>
              </p>
            }
          </div>
        </div>
      } @else {
        <div class="status-card">
          <div>
            <p class="status-label">Not signed in</p>
            <p class="status-value">Use your Microsoft work account to continue.</p>
          </div>
        </div>
      }


      <section class="permission-grid permission-grid--single" aria-label="Permission options">
        <article class="permission-card" [class.permission-card--connected]="this.userAccessConnected">
          <div class="permission-topline">
            <span class="permission-icon">
              <i class="ms-Icon ms-Icon--Flow" aria-hidden="true"></i>
            </span>
            @if (this.userAccessConnected) {
              <span class="permission-state">
                <i class="ms-Icon ms-Icon--SkypeCircleCheck" aria-hidden="true"></i>
                Connected
              </span>
            }
          </div>
          <h3>User consent</h3>
          <p>Read and manage the flows you can access. Best for makers and day-to-day troubleshooting.</p>
          <ul>
            <li>Read and manage Power Automate flows</li>
            <li>Access Power Apps service context</li>
            <li>Maintain access you have granted</li>
          </ul>
          @if (!this.userAccessConnected) {
            <button
              kendoButton
              type="button"
              class="secondary-action"
              themeColor="primary"
              (click)="loginM365($event)"
              >
              Sign in with M365 account
            </button>
          }
        </article>
      </section>

      <section class="help-panel">
        <div>
          <h3>Having sign-in issues?</h3>
          <p>These notes cover common Microsoft consent and Power Platform API changes.</p>
        </div>
        <div class="help-links">
          <button type="button" class="bug-report-btn" (click)="openBugReport()">
            Report a sign-in issue
            <i class="ms-Icon ms-Icon--Bug" aria-hidden="true"></i>
          </button>
          <a href="https://johnliu.net/blog/flow-studio-devlog-reported-for-phishing-and-woes-of-cloudflare/" target="_blank" rel="noopener noreferrer">
            Cloudflare warning notes, splitting subdomains (2025)
            <i class="ms-Icon ms-Icon--OpenInNewWindow" aria-hidden="true"></i>
          </a>
          <a href="https://johnliu.net/blog/blog-power-apps-api-changes-no-longer-accept-azure-management-token/" target="_blank" rel="noopener noreferrer">
            Power Apps API scope changes (2023)
            <i class="ms-Icon ms-Icon--OpenInNewWindow" aria-hidden="true"></i>
          </a>
          <a href="https://johnliu.net/blog/power-automate-api-changes-v2-admin-scope-now-needs-userimpersonation/" target="_blank" rel="noopener noreferrer">
            Admin consent scope changes (2023)
            <i class="ms-Icon ms-Icon--OpenInNewWindow" aria-hidden="true"></i>
          </a>
        </div>
      </section>

      @if (this.error) {
        <section class="error-panel">
          <h3>Last sign-in message</h3>
          <pre>{{ this.error | json }}</pre>
        </section>
      }
    </main>
  </section>
</div>
